import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { MapPin, Phone, Mail, Clock, User, HelpCircle, AlertTriangle, FileText, Building, CheckCircle2, Globe } from 'lucide-react';
export function ContactUs() {
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-997">
      <TopBar data-id="element-998" />
      <Header data-id="element-999" />
      <Navigation data-id="element-1000" />

      <main className="flex-grow" data-id="element-1001">
        {/* Hero Section */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-1002">
          <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-1003">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-1004">
              We're Here to Help
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-1005">
              Contact & FAQs
            </h1>
            <p className="text-lg lg:text-xl text-brand-muted max-w-3xl mx-auto leading-relaxed mb-8" data-id="element-1006">
              Get in touch with our expert team for help choosing the right
              product, identifying a replacement part, or planning a commercial
              project.
            </p>
            <div className="flex justify-center" data-id="element-1007">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/Live%20Rep.png" alt="Live Representative at Midatlantic Mailbox" className="h-16 object-contain" data-id="element-1008" />
            </div>
          </div>
        </section>

        {/* Contact Info & Hours */}
        <section className="py-16 bg-brand-goldWash border-b border-brand-border" data-id="element-1009">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1010">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1011">
              {/* Main Office */}
              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-1012">
                <div className="flex items-center gap-3 mb-6" data-id="element-1013">
                  <div className="w-12 h-12 rounded-full bg-brand-background text-brand-maroon flex items-center justify-center" data-id="element-1014">
                    <Building size={24} data-id="element-1015" />
                  </div>
                  <h2 className="text-2xl font-serif font-bold text-brand-charcoal" data-id="element-1016">
                    Main Office
                  </h2>
                </div>

                <div className="space-y-4 text-brand-muted" data-id="element-1017">
                  <div className="flex items-start gap-3" data-id="element-1018">
                    <MapPin size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1019" />
                    <p data-id="element-1020">
                      MidAtlantic Mailbox, Inc
                      <br data-id="element-1021" />
                      4507 Metropolitan Court Ste D<br data-id="element-1022" />
                      Frederick, MD 21704
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1023">
                    <Phone size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1024" />
                    <p data-id="element-1025">
                      <a href="tel:301-620-7585" className="hover:text-brand-maroon transition-colors" data-id="element-1026">
                        301-620-7585
                      </a>{' '}
                      or{' '}
                      <a href="tel:301-620-7867" className="hover:text-brand-maroon transition-colors" data-id="element-1027">
                        301-620-7867
                      </a>
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1028">
                    <Clock size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1029" />
                    <p data-id="element-1030">
                      Monday - Friday: 10:30AM - 5:00PM (EST)
                      <br data-id="element-1031" />
                      Closed on Saturdays and Sundays
                    </p>
                  </div>
                  <div className="flex items-start gap-3 pt-2" data-id="element-1032">
                    <Mail size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1033" />
                    <a href="mailto:customerservice@midatlanticmailboxes.com" className="text-brand-maroon hover:text-brand-maroonDark font-medium break-all" data-id="element-1034">
                      customerservice@midatlanticmailboxes.com
                    </a>
                  </div>
                </div>
              </div>

              {/* Internet & Commercial Sales */}
              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-1035">
                <div className="flex items-center gap-3 mb-6" data-id="element-1036">
                  <div className="w-12 h-12 rounded-full bg-brand-background text-brand-maroon flex items-center justify-center" data-id="element-1037">
                    <Globe size={24} data-id="element-1038" />
                  </div>
                  <h2 className="text-2xl font-serif font-bold text-brand-charcoal" data-id="element-1039">
                    Internet & Commercial Sales
                  </h2>
                </div>

                <div className="space-y-4 text-brand-muted" data-id="element-1040">
                  <div className="flex items-start gap-3" data-id="element-1041">
                    <Phone size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1042" />
                    <div className="space-y-1" data-id="element-1043">
                      <p data-id="element-1044">
                        <strong data-id="element-1045">Eastern region:</strong>{' '}
                        <a href="tel:240-575-5852" className="hover:text-brand-maroon transition-colors" data-id="element-1046">
                          240-575-5852
                        </a>
                      </p>
                      <p data-id="element-1047">
                        <strong data-id="element-1048">Western region:</strong>{' '}
                        <a href="tel:480-505-9240" className="hover:text-brand-maroon transition-colors" data-id="element-1049">
                          480-505-9240
                        </a>
                      </p>
                      <p data-id="element-1050">
                        <strong data-id="element-1051">Toll Free:</strong>{' '}
                        <a href="tel:800-469-1203" className="hover:text-brand-maroon transition-colors" data-id="element-1052">
                          800-469-1203
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1053">
                    <Clock size={20} className="text-brand-maroon shrink-0 mt-1" data-id="element-1054" />
                    <p data-id="element-1055">
                      Monday - Friday: 9:00AM to 5:00PM (MST)
                      <br data-id="element-1056" />
                      <span className="text-sm italic" data-id="element-1057">
                        Please note we have an East Coast & West Coast office
                        that operate in different time zones.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Team */}
        <section className="py-16 bg-white border-b border-brand-border" data-id="element-1058">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1059">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-8 text-center" data-id="element-1060">
              Our Team
            </h2>
            <p className="text-center text-brand-muted mb-10 max-w-2xl mx-auto" data-id="element-1061">
              Please feel free to contact any one of our team members directly
              via email or phone at{' '}
              <a href="tel:301-620-7585" className="text-brand-maroon hover:underline" data-id="element-1062">
                301-620-7585
              </a>
              .
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1063">
              {[{
              name: 'Anne Ingram',
              title: 'Chief Executive Officer & Owner',
              email: 'anne@midatlanticmailbox.biz'
            }, {
              name: 'Lora Dragovich',
              title: 'Lead Commercial & E Commerce Sales Manager',
              email: 'lorad@midatlanticmailboxes.com'
            }, {
              name: 'Brooke Ingram',
              title: 'Operations Manager & Street Sign Specialist',
              email: 'brooke@midatlanticmailbox.biz'
            }, {
              name: 'Rachel Ingram-Conway',
              title: 'Business Development & Residential Specialist',
              email: 'rachel@midatlanticmailbox.biz'
            }].map((member, idx) => <div key={idx} className="bg-brand-background p-6 rounded-xl border border-brand-border text-center flex flex-col items-center" data-id="element-1064">
                  <div className="w-14 h-14 rounded-full bg-brand-goldWash text-brand-maroon flex items-center justify-center mb-4" data-id="element-1065">
                    <User size={24} data-id="element-1066" />
                  </div>
                  <h3 className="font-bold text-brand-charcoal text-lg mb-1" data-id="element-1067">
                    {member.name}
                  </h3>
                  <p className="text-sm text-brand-muted mb-4 flex-grow" data-id="element-1068">
                    {member.title}
                  </p>
                  <a href={`mailto:${member.email}`} className="text-sm text-brand-maroon hover:text-brand-maroonDark font-medium break-all" data-id="element-1069">
                    {member.email}
                  </a>
                </div>)}
            </div>
          </div>
        </section>

        {/* Services & Communities */}
        <section className="py-16 bg-brand-background border-b border-brand-border" data-id="element-1070">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1071">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-1072">
              <div data-id="element-1073">
                <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-1074">
                  Your Mailbox Experts Are Here to Help!
                </h2>
                <ul className="space-y-4 text-brand-muted" data-id="element-1075">
                  <li className="flex items-start gap-3" data-id="element-1076">
                    <CheckCircle2 size={20} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1077" />
                    <span className="text-lg" data-id="element-1078">
                      Replacement CBU's & New Developments
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1079">
                    <CheckCircle2 size={20} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1080" />
                    <span className="text-lg" data-id="element-1081">
                      Advisal of Commercial Postal Codes & Ordinances
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1082">
                    <CheckCircle2 size={20} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1083" />
                    <span className="text-lg" data-id="element-1084">
                      Value Engineered Development Mailbox Mapping
                    </span>
                  </li>
                </ul>
              </div>

              <div data-id="element-1085">
                <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-1086">
                  Communities Serviced by Midatlantic Mailbox
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6 text-brand-muted" data-id="element-1087">
                  <a href="/3948.html" className="flex items-center gap-2 hover:text-brand-maroon transition-colors" data-id="element-1088">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1089" />
                    Regency at Dominion Valley: Haymarket, VA
                  </a>
                  <div className="flex items-center gap-2" data-id="element-1090">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1091" />
                    Lenah Mills: Aldie, VA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1092">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1093" />
                    Skeeter Lake: Roundhill, VA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1094">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1095" />
                    Brunswick Crossing: Frederick, MD
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1096">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1097" />
                    Villages at Urbana: Frederick, MD
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1098">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1099" />
                    Greencastle Green: Greencastle, PA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1100">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1101" />
                    Copper Run Drive: Monroe, LA
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1102">
                    <MapPin size={16} className="text-brand-gold" data-id="element-1103" />
                    Regency at Trotter's Point: Tinton Falls, NJ
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQs */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-1104">
          <div className="max-w-4xl mx-auto px-4" data-id="element-1105">
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-10 text-center" data-id="element-1106">
              Frequently Asked Questions
            </h2>

            <div className="space-y-6" data-id="element-1107">
              {/* General / Install */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1108">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1109">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1110" />
                  I didn’t buy my mailbox from Midatlantic Mailbox. Will you
                  still install it?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7" data-id="element-1111">
                  It depends! If you are in our service area and there is
                  availability on our schedule, we can complete a direct burial
                  installation. However we can only guarantee the craftsmanship
                  of the physical installation; any issues with the products
                  should be brought to the company you purchased from. Call{' '}
                  <a href="tel:301-620-7585" className="text-brand-maroon hover:underline" data-id="element-1112">
                    301-620-7585
                  </a>{' '}
                  to request an installation today!
                </p>
              </div>

              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1113">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1114">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1115" />
                  Do I need post office approval to replace my mailbox?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7" data-id="element-1116">
                  Unless you’re moving your mailbox location, you generally
                  don’t need USPS approval to complete a residential
                  installation. We’ll ensure your mailbox is compliant with USPS
                  regulations during installation. All of Midatlantic Mailbox’s
                  products are also USPS Approved.
                </p>
              </div>

              {/* 4C Mailboxes */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1117">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1118">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1119" />
                  Are 4C mailboxes USPS approved?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7 mb-4" data-id="element-1120">
                  Yes, 4C mailboxes are the newest USPS code-approved systems,
                  made per USPS regulations outlined in the Federal Registry. 4C
                  mailboxes meet or exceed STD-4C requirements for new
                  construction and major renovations.
                </p>
                <div className="pl-7 space-y-4" data-id="element-1121">
                  <div data-id="element-1122">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1123">
                      How are they installed?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1124">
                      Preferred installation is recessed into the wall, however
                      there is a surface-mounted or a depot option available.
                      Both may require USPS approval.
                    </p>
                  </div>
                  <div data-id="element-1125">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1126">
                      Are they ADA approved?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1127">
                      4C Mailboxes are produced to meet USPS code; ADA is a
                      separate entity. There are full USPS & ADA compliant units
                      available. Call 301-620-7585 to connect with a 4C
                      specialist.
                    </p>
                  </div>
                  <div data-id="element-1128">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1129">
                      What is a Parcel locker and is it required?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1130">
                      A Parcel Locker is required for all USPS package
                      deliveries. To be compliant, it must be 15” tall. For
                      every 10 tenant slots, 5 parcel lockers are required by
                      USPS Code.
                    </p>
                  </div>
                  <div data-id="element-1131">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1132">
                      Lead times & Customization?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1133">
                      Production varies from 4-6 weeks depending on quantity and
                      colors. There are limited custom options available.
                    </p>
                  </div>
                </div>
              </div>

              {/* 4B+ Mailboxes */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1134">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1135">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1136" />
                  Are Horizontal or Vertical (4B+) mailboxes USPS approved?
                </h3>
                <p className="text-brand-muted leading-relaxed pl-7 mb-4" data-id="element-1137">
                  No, 4B+ Horizontal and Vertical mailboxes are not USPS
                  approved for new construction, renovations, or updates. As of
                  July 2020 USPS Code Amendments, any renovation requires an
                  upgrade to CBU or 4C systems. They are only considered
                  approved if replacing existing mailboxes (at the discretion of
                  your local Postmaster). We ALWAYS advise confirming with your
                  local USPS Postmaster prior to purchasing.
                </p>
                <div className="pl-7 space-y-4" data-id="element-1138">
                  <div data-id="element-1139">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1140">
                      Customization & Installation?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1141">
                      Limited options for horizontal, no custom options for
                      vertical. Vertical can be surface or recessed-mounted.
                      Horizontal must be recessed.
                    </p>
                  </div>
                  <div data-id="element-1142">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1143">
                      Lead times?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1144">
                      Horizontal units: 6-8 weeks. Vertical units: 7-14 business
                      days. Transit time depends on location.
                    </p>
                  </div>
                  <div data-id="element-1145">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1146">
                      What is included?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1147">
                      Units include tenant locks with 2 keys each and number
                      slot card door ID per each door.
                    </p>
                  </div>
                </div>
              </div>

              {/* Street Signs */}
              <div className="bg-brand-background p-6 rounded-xl border border-brand-border" data-id="element-1148">
                <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1149">
                  <HelpCircle size={20} className="text-brand-maroon shrink-0" data-id="element-1150" />
                  Street Sign FAQs
                </h3>
                <div className="pl-7 space-y-4" data-id="element-1151">
                  <div data-id="element-1152">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1153">
                      I only need a replacement part - what do I do?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1154">
                      Call Midatlantic Mailbox! Our sign specialist can identify
                      the replacement part needed via photos to provide an
                      estimate.
                    </p>
                  </div>
                  <div data-id="element-1155">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1156">
                      How are street signs shipped?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1157">
                      Full systems ship via Freight due to post length. Single
                      blades ship standard. We offer Telescoping Poles to save
                      on freight charges.
                    </p>
                  </div>
                  <div data-id="element-1158">
                    <strong className="text-brand-charcoal block mb-1" data-id="element-1159">
                      What materials are they made of?
                    </strong>
                    <p className="text-brand-muted text-sm" data-id="element-1160">
                      Most systems (blade, bracket, post, base) are derived from
                      durable aluminum.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policies */}
        <section className="py-16 lg:py-24 bg-brand-charcoal text-white" data-id="element-1161">
          <div className="max-w-5xl mx-auto px-4" data-id="element-1162">
            <div className="text-center mb-12" data-id="element-1163">
              <FileText size={40} className="text-brand-gold mx-auto mb-4" data-id="element-1164" />
              <h2 className="text-3xl font-serif font-bold mb-4" data-id="element-1165">
                Our Policies
              </h2>
              <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-1166">
                Please review our return, damage, and cancellation policies. For
                excellent customer service, contact us at{' '}
                <a href="tel:240-575-5852" className="text-brand-gold hover:underline" data-id="element-1167">
                  240-575-5852
                </a>{' '}
                or{' '}
                <a href="tel:301-620-7585" className="text-brand-gold hover:underline" data-id="element-1168">
                  301-620-7585
                </a>
                .
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1169">
              {/* Returns */}
              <div className="bg-white/5 border border-white/10 p-6 rounded-xl" data-id="element-1170">
                <h3 className="text-xl font-bold text-brand-gold mb-3 flex items-center gap-2" data-id="element-1171">
                  <AlertTriangle size={20} data-id="element-1172" />
                  Return Policy
                </h3>
                <ul className="space-y-3 text-sm text-gray-300" data-id="element-1173">
                  <li data-id="element-1174">
                    • Email{' '}
                    <a href="mailto:customerservice@midatlanticmailboxes.com" className="text-white hover:underline" data-id="element-1175">
                      customerservice@midatlanticmailboxes.com
                    </a>{' '}
                    to obtain a return authorization number (RGA#). RGA is
                    required for all returns.
                  </li>
                  <li data-id="element-1176">
                    • Returns must be made within 30 days from receipt, in new
                    condition, and original packaging.
                  </li>
                  <li data-id="element-1177">
                    • Minimum restocking fee of 25% or $25 applies. Many
                    manufacturers may not allow returns if the item is not
                    defective.
                  </li>
                  <li data-id="element-1178">
                    • Shipping charges for the return are the customer's
                    responsibility. Original shipping charges are
                    non-refundable.
                  </li>
                  <li data-id="element-1179">
                    • Products that have been installed or customized are not
                    returnable.
                  </li>
                  <li data-id="element-1180">
                    • Call{' '}
                    <a href="tel:800-806-7997" className="text-white hover:underline" data-id="element-1181">
                      800-806-7997
                    </a>{' '}
                    to determine your return requirements.
                  </li>
                </ul>
              </div>

              {/* Damages & Cancellations */}
              <div className="space-y-8" data-id="element-1182">
                <div className="bg-white/5 border border-white/10 p-6 rounded-xl" data-id="element-1183">
                  <h3 className="text-xl font-bold text-brand-gold mb-3" data-id="element-1184">
                    Damage Inspections
                  </h3>
                  <p className="text-sm text-gray-300 mb-3" data-id="element-1185">
                    <strong data-id="element-1186">
                      All items must be inspected for concealed damage or
                      shortage within 3 days of delivery to receive credit.
                    </strong>
                  </p>
                  <p className="text-sm text-gray-300" data-id="element-1187">
                    Report damages, defects, or shipping errors within 3
                    business days by calling{' '}
                    <a href="tel:800-806-7997" className="text-white hover:underline" data-id="element-1188">
                      1-800-806-7997
                    </a>
                    . Damaged products must be left in the original box with
                    packing materials. Do not discard any items; a shipping
                    representative may need to inspect them. Orders returned or
                    discarded without authorization will NOT be refunded.
                  </p>
                </div>

                <div className="bg-white/5 border border-white/10 p-6 rounded-xl" data-id="element-1189">
                  <h3 className="text-xl font-bold text-brand-gold mb-3" data-id="element-1190">
                    Custom Orders & Cancellations
                  </h3>
                  <p className="text-sm text-gray-300 mb-3" data-id="element-1191">
                    <strong data-id="element-1192">Custom Orders:</strong> Address plaques,
                    personalized mailboxes, or engraved items are non-refundable
                    unless damaged/defective. America’s Finest and Bacova
                    mailboxes are made to order by hand and are non-returnable.
                  </p>
                  <p className="text-sm text-gray-300" data-id="element-1193">
                    <strong data-id="element-1194">Cancellations:</strong> Many products ship within
                    24-48 hrs. To cancel, notify us immediately at{' '}
                    <a href="mailto:customerservice@midatlanticmailboxes.com" className="text-white hover:underline" data-id="element-1195">
                      customerservice@midatlanticmailboxes.com
                    </a>
                    . If shipped, you are responsible for return shipping and
                    restocking fees.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1196" />
      <MobileStickyBar data-id="element-1197" />
    </div>;
}